import { Configuration, IntentApi } from '@api/intent';
import { useIdentity } from '@interhyp/platform-auth';
import { getAPIPath } from '@interhyp/platform-request';
import { IntentFact, IntentFacts } from '@interhyp/shared-interim-portal';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

const service = new IntentApi(
  new Configuration({
    basePath: getAPIPath('intent'),
  }),
);

export const useMyIntents = (currentIntentCounter = 0): IntentFact[] | undefined => {
  const identity = useIdentity();

  const { data: intents } = useQuery({
    queryKey: ['myIntents', identity?.userId, currentIntentCounter],
    queryFn: async (): Promise<AxiosResponse<IntentFacts>> => {
      return service.intentsOfAuthenticatedCustomer();
    },
  });
  return intents?.data.data;
};
